import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { CdsButtonConfig } from '@cds/ng-core/button';
import { MatDialogRef, CdsPopupModule } from '@cds/ng-web-components/popup';
import { Subscription } from 'rxjs';
import { LanguageChangeService } from 'src/app/shared/language-change.service';
import { CdsButtonModule } from '@cds/ng-web-components/button';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@Component({
  selector: 'app-employee-delegation-change-pop',
  templateUrl: './employee-delegation-change-pop.component.html',
  imports: [CdsPopupModule, CdsButtonModule, CdsLanguageModule],
})
export class EmployeeDelegationChangePopComponent implements OnInit, OnDestroy {
  private languageChangeService = inject(LanguageChangeService);
  private dialogRef = inject<MatDialogRef<EmployeeDelegationChangePopComponent>>(MatDialogRef);

  language = 'EN';
  lanSubscription?: Subscription;

  agreeButtonConfig: CdsButtonConfig = {
    label: this.language === 'EN' ? 'Continue' : '繼續',
    size: 'sm',
    style: 'primary',
    disabled: false,
  };

  disagreeButtonConfig: CdsButtonConfig = {
    label: this.language === 'EN' ? 'Cancel' : '取消',
    size: 'sm',
    style: 'primary',
    disabled: false,
  };

  ngOnInit(): void {
    this.lanSubscription = this.languageChangeService.lanSubject.subscribe(lan => {
      this.language = lan === 'en' ? 'EN' : 'TC';
    });
  }

  ngOnDestroy(): void {
    this.lanSubscription?.unsubscribe();
  }

  agree() {
    this.dialogRef.close({ agree: true });
  }

  disagree() {
    this.dialogRef.close({ agree: false });
  }
}
